/* eslint-disable max-lines */

import { OLD_DESIGN_FILTERS, REDESIGN_FILTERS } from './constants';
import { FDealType, FOfferType, isAvailable, isAvailableStrict } from '../../../../../JsonQuery';
import { TFilter } from '../../../types/advancedFilters';
import { IJsonQuery } from '../../../types/jsonQuery';

interface IFilterList {
  isRedesign?: boolean;
  availability(jsonQuery: IJsonQuery): boolean;
  list: TFilter[];
}

const FILTERS_LIST: IFilterList[] = [
  {
    availability: isAvailableStrict(FDealType.Sale, FOfferType.FlatNew),
    list: [
      'specialOffers',
      'withNeighbors',
      'completionYear',
      'undergroundTime',
      'offerType',
      'squareMeterArea',
      'layout',
      // Видео
      // Наличие фото
      // Тип объявления
      'ceilingHeight',
      'floor',
      'floors',
      'constructionType',
      'decorationsList',
      'saleType',
      'apartments',
      'electronicTrading',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.Sale, FOfferType.Room),
    list: [
      'withNeighbors',
      'dealType',
      'undergroundTime',
      'squareMeterArea',
      'flatRooms',
      'roomsInDeal',
      'layout',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'kitchenStove',
      'repair',
      'floor',
      'floors',
      'windows',
      'constructionYear',
      'constructionType',
      'demolition',
      'elevators',
      'parking',
      'saleType',
      'electronicTrading',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.Sale, FOfferType.FlatShared),
    list: [
      'withNeighbors',
      'dealType',
      'undergroundTime',
      'squareMeterArea',
      'flatRooms',
      'layout',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'kitchenStove',
      'repair',
      'floor',
      'floors',
      'windows',
      'constructionYear',
      'constructionType',
      'demolition',
      'elevators',
      'parking',
      'saleType',
      'electronicTrading',
      'apartments',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.Sale, FOfferType.Garage),
    list: [
      'undergroundTime',
      'squareMeterArea',
      'garageType',
      'garageStatus',
      'garageUtilities',
      'parking',
      'publicationDate',
      'electronicTrading',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },

  {
    availability: isAvailable(FDealType.RentLongterm, FOfferType.Flat),
    list: [
      'withNeighbors',
      'dealType',
      'rentalPeriod',
      'undergroundTime',
      'facilities',
      'livingConditions',
      'squareMeterArea',
      'layout',
      'apartments',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'bathType',
      'kitchenStove',
      'repair',
      'windows',
      'floor',
      'floors',
      'constructionYear',
      'constructionType',
      'demolition',
      'elevators',
      // Пандус
      'parking',
      'rentTerms',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.RentLongterm, FOfferType.Room),
    list: [
      'withNeighbors',
      'dealType',
      'rentalPeriod',
      'undergroundTime',
      'facilities',
      'livingConditions',
      'squareMeterArea',
      'flatRooms',
      'roomsInDeal',
      'layout',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'bathType',
      'kitchenStove',
      'repair',
      'floor',
      'floors',
      'windows',
      'constructionYear',
      'constructionType',
      'demolition',
      'elevators',
      // Пандус
      'parking',
      // Состав съемщиков
      'rentTerms',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.RentLongterm, FOfferType.Bed),
    list: [
      'withNeighbors',
      'dealType',
      'rentalPeriod',
      'undergroundTime',
      'facilities',
      'livingConditions',
      'squareMeterArea',
      'flatRooms',
      'roomsInDeal',
      'layout',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'bathType',
      'kitchenStove',
      'repair',
      'floor',
      'floors',
      'windows',
      'constructionYear',
      'constructionType',
      'elevators',
      // Пандус
      'parking',
      // Состав съемщиков
      'rentTerms',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.RentLongterm, FOfferType.House | FOfferType.HousePart | FOfferType.Townhouse),
    list: [
      'withNeighbors',
      'rentalPeriod',
      'fromMKAD',
      'undergroundTime',
      'suburbanArea',
      'facilities',
      'suburbanFacilities',
      'bathType',
      'suburbanBathroom',
      'repair',
      'floors',
      'constructionType',
      'heatingType',
      'constructionYear',
      'rentTerms',
      'livingConditions',
      'publicationDate',
      'dealType',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.RentLongterm, FOfferType.Garage),
    list: [
      'undergroundTime',
      'squareMeterArea',
      'garageType',
      'garageStatus',
      'garageUtilities',
      'parking',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.RentDaily, FOfferType.Flat),
    list: [
      'onlineBooking',
      'withNeighbors',
      'dealType',
      'undergroundTime',
      'facilities',
      'livingConditions',
      'squareMeterArea',
      'apartments',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'bathType',
      'kitchenStove',
      'repair',
      'floor',
      'floors',
      'windows',
      'constructionYear',
      'constructionType',
      'elevators',
      // Пандус
      'parking',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.RentDaily, FOfferType.Room | FOfferType.Bed),
    list: [
      'onlineBooking',
      'withNeighbors',
      'dealType',
      'undergroundTime',
      'facilities',
      'livingConditions',
      'squareMeterArea',
      'flatRooms',
      'roomsInDeal',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'bathType',
      'kitchenStove',
      'repair',
      'floor',
      'floors',
      'windows',
      'constructionYear',
      'constructionType',
      'elevators',
      // Пандус
      'parking',
      // Состав съемщиков
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.RentDaily, FOfferType.House),
    list: [
      'onlineBooking',
      'withNeighbors',
      'fromMKAD',
      'undergroundTime',
      'suburbanAreaDailyrent',
      'facilities',
      'livingConditions',
      'suburbanFacilities',
      'bathType',
      'suburbanBathroom',
      'repair',
      'floors',
      'constructionType',
      'heatingType',
      'constructionYear',
      'publicationDate',
      'dealType',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
];

const UNKNOWN_FILTER = {
  availability: isAvailable(FDealType.Any, FOfferType.Any),
  list: ['withNeighbors', 'publicationDate', 'containWords', 'excludeWords', 'contact', 'offerId'],
};

export function getAvailableFilters(jsonQuery: IJsonQuery, isRedesign?: boolean): TFilter[] {
  const filtersList = [
    ...FILTERS_LIST,
    ...(isRedesign ? REDESIGN_FILTERS : OLD_DESIGN_FILTERS),
    UNKNOWN_FILTER,
  ] as IFilterList[];

  const type = filtersList.find((f: IFilterList) => f.availability(jsonQuery));

  return (type && type.list) || [];
}
